import {useState} from 'react';

const useTimePicker = (props) => {
    const [value, setValue] = useState(props.value ? props.value : null);

    const [valid, setValid] = useState(true);

    const [style, setStyle] = useState({});

    const onOpen = (event, open) => {
        if (open) {
            setStyle({'z-index': '9999', ...props.style});
        } else {
            setStyle({...props.style});
        }
    };

    const onChange = (event, _value) => {
        setValid(true);
        setValue(_value);
        if (props.onChange && typeof props.onChange == "function") {
            props.onChange(event, _value);
        }
    };

    const onClear = (event) => {
        setValid(true);
        setValue("");
        if (props.onChange && typeof props.onChange == "function") {
            props.onChange(event, "");
        }
        if (props.onClear && typeof props.onClear == "function") {
            props.onClear(event);
        }
    };

    return {
        props: {
            value,
            valid,
            onOpen,
            onChange,
            onClear,
            style,
        },
        setValid,
        setValue,
    };
};

export default useTimePicker;
